import { render, staticRenderFns } from "./DashboardGridStack.vue?vue&type=template&id=70c4450e&"
import script from "./DashboardGridStack.vue?vue&type=script&lang=js&"
export * from "./DashboardGridStack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports